import * as React from "react";
import "./BookCard.css";
import Button from "../../Button/Button";
import {
	LibraryCard,
	CardType,
	CardPropertyType,
} from "../../../types/LibraryCard";
import { getDatePeriod, MOBILE_MAX_WIDTH } from "../../../utils";
import { parseISO } from "date-fns";
import Dialog from "@material-ui/core/Dialog/Dialog";
import IconButton from "@material-ui/core/IconButton";
import EditBookCard from "../../EditBookCard/EditBookCard";
import QuickButton from "./QuickButton/QuickButton";
import ClockIcon from "@material-ui/icons/Schedule";
import Play from "@material-ui/icons/VideoLibrary";
import Check from "@material-ui/icons/Beenhere";
import MediaQuery, { useMediaQuery } from "react-responsive";
import { CallbacksContext } from "../BookCalendar";
import CloseIcon from "@material-ui/icons/Close";
import Cancel from "./Cancel/Cancel";
import Card from "../../Feed/Card/Card";
import UserList from "../../BookPage/UserList/UserList";

interface Props {
	card?: LibraryCard;
}

const BookCard: React.FunctionComponent<Props> = ({ card }) => {
	const [editBookOpen, setEditBookOpen] = React.useState(false);
	const [forcedSection, setforcedSection] = React.useState<CardType>(null);

	const isMobile = useMediaQuery({ maxWidth: 600 });

	const callbacks = React.useContext(CallbacksContext);

	const showEditBookOpen = () => setEditBookOpen(true);
	const hideEditBookOpen = () => {
		setEditBookOpen(false);
		setforcedSection(null);
	};

	const openForcedSection = (type: CardType) => {
		setforcedSection(type);
		setEditBookOpen(true);
	};

	const datePeriod = React.useMemo(() => {
		if (!card) {
			return;
		}

		return getDatePeriod(
			parseISO(card.properties[CardPropertyType.DateBegin]),
			card.properties[CardPropertyType.DateFinish]
				? parseISO(card.properties[CardPropertyType.DateFinish])
				: null,
			'с ',
			' по ',
			card.cardType === CardType.WantRead
		);
	}, [card]);

	if (!card) {
		return (
			<div className="book-card">
				<div className="book-card__welcome">
					<div>Выберите книгу из списка слева</div>
				</div>
			</div>
		);
	}

	return (
		<div className="book-card">
			{card && (
				<div className="book-card__book">
					<Card
						book={card.book}
					/>

					<UserList book={card.book} initialLabel="Также добавили: "/>

					<div className="book-card__summary">
						<div className="book-card__details">
							{card.cardType === CardType.WantRead ? (
								<>
									<ClockIcon /> Запланировано
								</>
							) : card.cardType === CardType.ReadNow ? (
								<>
									<Play /> Читаю
								</>
							) : (
								<>
									<Check /> Прочитано
								</>
							)}

							{datePeriod && card.cardType !== CardType.AlreadyRead
								? ` ${datePeriod}`
								: ""}
						</div>

						<MediaQuery minWidth={MOBILE_MAX_WIDTH}>
							<div>
								<Button onClick={showEditBookOpen} type="primary">
									Изменить
								</Button>
							</div>
						</MediaQuery>
					</div>

					<MediaQuery maxWidth={MOBILE_MAX_WIDTH}>
						<div className="book-card__controls">
							<QuickButton libraryCard={card} onClick={openForcedSection} />

							{card.cardType === CardType.WantRead && (
								<Cancel
									card={card}
									saveCardProperties={callbacks.saveCardProperties}
									deleteCard={callbacks.deleteCard}
								/>
							)}
						</div>
					</MediaQuery>

					<Dialog
						maxWidth="md"
						fullScreen={isMobile}
						open={editBookOpen}
						onClose={hideEditBookOpen}
						classes={{
							paper: "book-calendar-dialogCard__paper",
						}}
					>
						{isMobile && (
							<div className="book-calendar-dialogCard-toolbar">
								<IconButton onClick={hideEditBookOpen}>
									<CloseIcon />
								</IconButton>

								<div className="book-calendar-dialogCard-toolbar__header">
									Изменить
								</div>
							</div>
						)}

						<EditBookCard
							book={card.book}
							forcedSection={forcedSection}
							forcedStartRead={
								forcedSection === CardType.AlreadyRead
									? card.properties[CardPropertyType.DateBegin]
									: null
							}
							onSaved={hideEditBookOpen}
							libraryCard={card}
							saveCard={callbacks.addCard}
							saveProperties={callbacks.saveCardProperties}
							onClose={hideEditBookOpen}
						/>
					</Dialog>
				</div>
			)}
		</div>
	);
};

export default BookCard;
